// Main JavaScript file
document.addEventListener('DOMContentLoaded', () => {
	console.log('Document ready!');

	const accordionItems = document.querySelectorAll('.sh-accordion__item');

	// Initialize all accordion contents to height 0
	accordionItems.forEach(item => {
		const content = item.querySelector('.sh-accordion__content');
		gsap.set(content, { height: 0 });
	});

	accordionItems.forEach(item => {
		const header = item.querySelector('.sh-accordion__header');
		const content = item.querySelector('.sh-accordion__content');
		const contentInner = item.querySelector('.sh-accordion__content-inner');
		const toggle = item.querySelector('.sh-accordion__toggle');
		const biosimilarBtns = item.querySelector('.drug-info__view-biosimilars a');
		// DIsable the a link in biosimilarBtns
		if (biosimilarBtns) {
			biosimilarBtns.addEventListener('click', e => {
				e.preventDefault();
			});
		}
		// biosimilarBtns.addEventListener('click', e => {
		// 	e.preventDefault();
		// });
		// Click event

		header.addEventListener('click', () => {
			const isActive = item.classList.contains('active');

			// Close all accordion items
			accordionItems.forEach(otherItem => {
				if (otherItem !== item || isActive) {
					otherItem.classList.remove('active');
					gsap.to(otherItem.querySelector('.sh-accordion__content'), {
						height: 0,
						duration: 0.3,
						ease: 'power2.out',
						overwrite: true, // Ensures no conflicting animations
					});
					otherItem.querySelector('.sh-accordion__toggle').classList.remove('active');
				}
			});

			if (!isActive) {
				// Open clicked accordion item
				item.classList.add('active');

				// Get the height of the inner content for accurate animation
				const innerHeight = contentInner.offsetHeight;

				gsap.to(content, {
					height: innerHeight,
					duration: 0.3,
					ease: 'power2.out',
					overwrite: true, // Ensures no conflicting animations
					onComplete: function () {
						// Don't set to auto as it can cause layout issues
						// Instead rely on the precise pixel height we calculated
						gsap.set(content, { height: innerHeight });
					},
				});
				toggle.classList.add('active');
			}
			// Window resize
			window.addEventListener('resize', () => {
				const isActive = item.classList.contains('active');
				if (isActive) {
					const innerHeight = contentInner.offsetHeight;
					gsap.set(content, { height: innerHeight });
				}
			});
		});
	});
});
